import { useFormContext } from "react-hook-form";

import { useTheme } from "@up/data";

export function PartnerPPAccept({ isDomestic }: { isDomestic: boolean }) {
  const { register } = useFormContext();
  const theme = useTheme();

  const PARTNER_KEY = "partner-tou-pp-accept";
  const partnerRegisterProps = register(PARTNER_KEY);

  const KAPLAN_KEY = "pp-accept";
  const kaplanRegisterProps = register(KAPLAN_KEY);

  return (
    <div>
      {isDomestic ? (
        <p className="text-sm" data-testid="privacy-policy-text-domestic">
          By pressing &quot;Next Page&quot; below, which you acknowledge is your
          electronic signature and legally valid, you agree to the{" "}
          {theme.partnerOnlineName}{" "}
          <a href="/privacy-policy" className="underline">
            Privacy Policy
          </a>{" "}
          (
          <a
            href="/privacy-policy-addendum-for-california-residents"
            className="underline"
          >
            California Notice At Collection
          </a>
          ), which governs the processing and handling of your data. You{" "}
          {theme.noGuardian ? null : <>(or your parent/guardian)</>} may revoke
          this consent at any time by contacting our service provider at{" "}
          <a
            className="underline"
            href="mailto:privacy.universitypartners@kaplan.com"
          >
            privacy.universitypartners@kaplan.com
          </a>{" "}
          . You also accept (by pressing Next Page) the{" "}
          <a
            href={theme.partnerPrivacyPolicy}
            target="_blank"
            className="underline"
            rel="noreferrer"
          >
            {theme.partnerName} Privacy Policy
          </a>
          , consent to which may be revoked as described therein.
        </p>
      ) : (
        <p className="text-sm" data-testid="privacy-policy-text-international">
          By pressing &quot;Next Page&quot; below, which you acknowledge is your
          electronic signature and legally valid, you agree to the{" "}
          {theme.partnerOnlineName}{" "}
          <a
            href={theme.partnerPrivacyPolicy}
            target="_blank"
            className="underline"
            rel="noreferrer"
          >
            Privacy Policy
          </a>{" "}
          , which governs the processing and handling of your data, and consent
          to the transfer of your data to the United States. Emails are sent by{" "}
          {theme.partnerName}'s service provider Kaplan North America, LLC, 1515
          W. Cypress Creek Road, Fort Lauderdale, FL 33309. You{" "}
          {theme.noGuardian ? null : <>(or your parent/guardian)</>} may revoke
          your consent or unsubscribe by contacting Kaplan North America at{" "}
          <a
            className="underline"
            href="mailto:privacy.universitypartners@kaplan.com"
          >
            privacy.universitypartners@kaplan.com
          </a>{" "}
          . You also accept (by pressing &quot;Next Page&quot;) the{" "}
          <a
            href={theme.partnerPrivacyPolicy}
            target="_blank"
            className="underline"
            rel="noreferrer"
          >
            {theme.partnerName} Privacy Policy
          </a>
          , consent to which may be revoked as described therein.
        </p>
      )}
      <input
        id={PARTNER_KEY}
        type="hidden"
        {...partnerRegisterProps}
        value="true"
      />
      <input
        id={KAPLAN_KEY}
        type="hidden"
        {...kaplanRegisterProps}
        value="true"
      />
    </div>
  );
}
